// extracted by mini-css-extract-plugin
export default {"notification-badge":"kJlOjuI","notification-badge--has-value":"W2OWapo"};